var map = {
	"./en/boring.json": 102,
	"./en/contact.json": 103,
	"./en/information.json": 104,
	"./en/meet_and_code.json": 105,
	"./en/navigation.json": 106,
	"./en/partners_page.json": 107,
	"./fr/boring.json": 108,
	"./fr/contact.json": 109,
	"./fr/information.json": 110,
	"./fr/meet_and_code.json": 111,
	"./fr/navigation.json": 112,
	"./fr/partners_page.json": 113,
	"./nl/boring.json": 114,
	"./nl/contact.json": 115,
	"./nl/information.json": 116,
	"./nl/navigation.json": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;